import { render } from "./CardBoletim.vue?vue&type=template&id=ee6fac64"
import script from "./CardBoletim.vue?vue&type=script&lang=js"
export * from "./CardBoletim.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rhylton/Sites/intranet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__